import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  const currentPath = window.location.pathname;

  if (!token) {
    if (currentPath.startsWith("/agent")) {
      return <Navigate to="/agent/login" replace />;
    } else if (currentPath.startsWith("/admin")) {
      return <Navigate to="/admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  return element;
};

export default ProtectedRoute;
